class Rely {
	constructor(showWhenChecked=true) {
		this.showWhenChecked = showWhenChecked;
		for (var el of $('[data-sma-js-relies-on]').toArray()) {
			this.initializeElement($(el));
		}
	}

	initializeElement(element) {
		let targets = $(element).attr('data-sma-js-relies-on').split(',');
		$(targets).each((i, target) => {
			target = $(target);
			if (target.length) {
				if (target.is(':checkbox')) {
					this.initializeCheckbox(target, element);
				}
				else if (target.is(':radio')) {
					this.initializeRadio(target, element);
				}
			}
		});
	}

	initializeCheckbox(target, element) {
		let modifier = e => {
			if (this.showWhenChecked === target.is(':checked')) {
				element.fadeIn();
			}
			else {
				element.hide();
			}
		}

		target.bind('change', modifier);
		target.bind('draft-loaded', modifier);

		modifier();
	}

	initializeRadio(target, element) {
		let modifier = e => {
			if (this.showWhenChecked === target.is(':checked')) {
				element.fadeIn();
			}
			else {
				element.hide();
			}
		}

		$(`[name=${target.attr('name')}]`).bind('change', modifier);

		modifier();
	}
}

module.exports = Rely;
